export default __webpack_public_path__ + "static/media/logo.26324b12.png";